import { render, staticRenderFns } from "./m-mechanism.vue?vue&type=template&id=760bec21&scoped=true&"
import script from "./m-mechanism.vue?vue&type=script&lang=ts&"
export * from "./m-mechanism.vue?vue&type=script&lang=ts&"
import style0 from "./m-mechanism.vue?vue&type=style&index=0&id=760bec21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760bec21",
  null
  
)

export default component.exports